import { ref, reactive, onMounted } from "vue"
import { lightTheme, darkTheme } from "~/config/theme.config"
import { useEventListener } from "@vueuse/core"
import { useCookie } from "#app"

export const useTheme = () => {
  const themeCookie = useCookie<'light' | 'dark'>('theme')
  const themeName = ref<'light' | 'dark'>(themeCookie.value || 'light')
  const colors = reactive({ ... (themeName.value === 'dark' ? darkTheme : lightTheme) })

  const applyTheme = (name: "light" | "dark") => {
    themeName.value = name
    const theme = name === "dark" ? darkTheme : lightTheme

    Object.keys(theme).forEach((key) => {
      // @ts-ignore
      colors[key] = theme[key]
      if (typeof document !== "undefined") {
        document.documentElement.style.setProperty(`--${key}`, theme[key])
      }
    })

    if (typeof document !== "undefined") {
      document.documentElement.classList.remove("light", "dark")
      document.documentElement.classList.add(name)
    }

    themeCookie.value = name
  }

  const toggleTheme = () =>
    applyTheme(themeName.value === "dark" ? "light" : "dark")

  onMounted(() => {
    if (typeof window === "undefined") return
  
    // const prefersDark = window.matchMedia("(prefers-color-scheme: dark)")
    // applyTheme(themeCookie.value || (prefersDark.matches ? "dark" : "light"))
  
    // // SSR-safe listener
    // useEventListener(prefersDark, "change", (e: MediaQueryListEvent) => {
    //   applyTheme(e.matches ? "dark" : "light")
    // })
 
        // Always default to light unless cookie says otherwise
        applyTheme("light")

  })

  return { colors, themeName, applyTheme, toggleTheme }
}